__turbopack_context__.v({
  "bannerContainer": "BreakingNewsBanner-module-scss-module__nOZT7G__bannerContainer",
  "hiddenBanner": "BreakingNewsBanner-module-scss-module__nOZT7G__hiddenBanner",
  "progressBar": "BreakingNewsBanner-module-scss-module__nOZT7G__progressBar",
});
